import React, { Component } from "react";
import { connect } from "react-redux";
import { preciseNumber } from "../../store/reducers/cart";
import dairyFreeIcon from "./assests/no-milk.png";
import glutenFreeIcon from "./assests/gluten-free.png";
import sugarFreeIcon from "./assests/sugar-free.png";
import nutFreeIcon from "./assests/peanut-free.png";
import organicIcon from "./assests/bio_480.png";
import vegetarianIcon from "./assests/leaf.png";
import veganIcon from "./assests/vegan.png";
import caloriesIcon from "./assests/calories.png";
import carbohydratesIcon from "./assests/carbohydrates.png";
import fatIcon from "./assests/trans-fat.png";
import proteinIcon from "./assests/whey.png";
import glutenIcon from "./assests/gluten.png";
import nutsSesameIcon from "./assests/nuts_sesame.png";
import dairyIcon from "./assests/dairy.png";
import eggIcon from "./assests/egg.png";
import seafoodShellfishIcon from "./assests/seafood_shellfish.png";
import chilliIcon from "./assests/chilli.png";


export class NutritionalFacts extends Component {
  state = {};

  render() {
    const language = this.props.language;

    const { nutritionalFacts, fromPage } = this.props;
    return (
      <>
        <p
          className={
            fromPage === "checkout"
              ? "box-title my-2"
              : "font-weight-bold my-2 mx-3 "
          }
          style={{
            textAlign: language == "english" ? "left" : "right",
          }}
        >
          {language == "english" ? "Nutritional Facts" : "القيم الغذائية"}
        </p>
        <div
          className="mb-3 w-100 "
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "center",
            backgroundColor: fromPage === "checkout" && "white",
            height: fromPage === "checkout" && 130,
          }}
        >
          {nutritionalFacts.totalCalories > 0 && (
            <div
              style={{
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div className="my-2">
                {language == "english" ? "Calories" : " السعرات الحرارية"}
              </div>
              <div className="my-2">
                <img src={caloriesIcon} style={{ height: 25, width: 25 }} />
              </div>
              <div className="my-2">
                {language == "english"
                  ? preciseNumber(nutritionalFacts.totalCalories) + "kcal"
                  : " سعرة حرارية" +
                    preciseNumber(nutritionalFacts.totalCalories)}
              </div>
            </div>
          )}
          {nutritionalFacts.totalProtein > 0 && (
            <div
              style={{
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div className="my-2">
                {language == "english" ? "Protein" : "البروتين"}
              </div>
              <div className="my-2">
                <img src={proteinIcon} style={{ height: 25, width: 25 }} />
              </div>
              <div className="my-2">
                {language == "english"
                  ? preciseNumber(nutritionalFacts.totalProtein) + "g"
                  : "جم" + preciseNumber(nutritionalFacts.totalProtein)}
              </div>
            </div>
          )}
          {nutritionalFacts.totalFats > 0 && (
            <div
              style={{
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div className="my-2">
                {language == "english" ? "Fats" : "الدهون"}
              </div>
              <div className="my-2">
                <img src={fatIcon} style={{ height: 25, width: 25 }} />
              </div>
              <div className="my-2">
                {language == "english"
                  ? preciseNumber(nutritionalFacts.totalFats) + "g"
                  : "جم" + preciseNumber(nutritionalFacts.totalFats)}
              </div>
            </div>
          )}
          {nutritionalFacts.totalCarbs > 0 && (
            <div
              style={{
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div className="my-2">
                {language == "english" ? "Carbs" : "الكربوهيدرات"}
              </div>
              <div className="my-2">
                <img
                  src={carbohydratesIcon}
                  style={{ height: 25, width: 25 }}
                />
              </div>
              <div className="my-2">
                {language == "english"
                  ? preciseNumber(nutritionalFacts.totalCarbs) + "g"
                  : "جم" + preciseNumber(nutritionalFacts.totalCarbs)}
              </div>
            </div>
          )}
        </div>
        {fromPage != "checkout" &&
          (nutritionalFacts?.isDairyFree ||
            nutritionalFacts?.isSugarFree ||
            nutritionalFacts?.isGlutenFree ||
            nutritionalFacts?.isNutFree ||
            nutritionalFacts?.isOrganic ||
            nutritionalFacts?.isVegan ||
            nutritionalFacts?.isVegetarian ||
            nutritionalFacts?.containsGluten ||
            nutritionalFacts?.containsNutsSesame ||
            nutritionalFacts?.containsDairy ||
            nutritionalFacts?.containsEgg ||
            nutritionalFacts?.containsSeafoodShellfish ||
            nutritionalFacts?.containsChilli) && (
            <>
              <p class=" font-weight-bold mb-3 mx-3 ">
                {language == "english"
                  ? "Dietary Information"
                  : "المعلومات الغذائية"}
              </p>

              <div
                className="mb-2 w-100"
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  alignItems: "flex-start",
                  flexWrap: "wrap",
                  textAlign: "center",
                }}
              >
                {nutritionalFacts.isDiaryFree && (
                  <div
                    className="mb-1"
                    style={{
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      width: 75,
                    }}
                  >
                    <div className="mb-2">
                      <img
                        src={dairyFreeIcon}
                        style={{ height: 25, width: 25 }}
                      />
                    </div>
                    <div className="mb-2">
                      {language == "english" ? "DF" : "خالي من منتجات الألبان"}
                    </div>
                  </div>
                )}
                {nutritionalFacts.isSugarFree && (
                  <div
                    className="mb-1"
                    style={{
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      width: 75,
                    }}
                  >
                    <div className="mb-2">
                      <img
                        src={sugarFreeIcon}
                        style={{ height: 25, width: 25 }}
                      />
                    </div>
                    <div className="mb-2">
                      {language == "english" ? "SF" : "خالي من السكر"}
                    </div>
                  </div>
                )}
                {nutritionalFacts.isGlutenFree && (
                  <div
                    className="mb-1"
                    style={{
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      width: 75,
                    }}
                  >
                    <div className="mb-2">
                      <img
                        src={glutenFreeIcon}
                        style={{ height: 25, width: 25 }}
                      />
                    </div>
                    <div className="mb-2">
                      {language == "english" ? "GF" : "خالي من الغلوتين"}
                    </div>
                  </div>
                )}
                {nutritionalFacts.isNutFree && (
                  <div
                    className="mb-1"
                    style={{
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      width: 75,
                    }}
                  >
                    <div className="mb-2">
                      <img
                        src={nutFreeIcon}
                        style={{ height: 25, width: 25 }}
                      />
                    </div>
                    <div className="mb-2">
                      {language == "english" ? "NF" : "خالي من المكسرات"}
                    </div>
                  </div>
                )}
                {nutritionalFacts.isOrganic && (
                  <div
                    className="mb-1"
                    style={{
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      width: 75,
                    }}
                  >
                    <div className="mb-2">
                      <img
                        src={organicIcon}
                        style={{ height: 25, width: 25 }}
                      />
                    </div>
                    <div className="mb-2">
                      {language == "english" ? "Organic" : "عضوي"}
                    </div>
                  </div>
                )}
                {nutritionalFacts.isVegan && (
                  <div
                    className="mb-1"
                    style={{
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      width: 75,
                    }}
                  >
                    <div className="mb-2">
                      <img src={veganIcon} style={{ height: 25, width: 25 }} />
                    </div>
                    <div className="mb-2">
                      {language == "english" ? "Vegan" : "فيغن"}
                    </div>
                  </div>
                )}
                {nutritionalFacts.isVegetarian && (
                  <div
                    className="mb-1"
                    style={{
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      width: 75,
                    }}
                  >
                    <div className="mb-2">
                      <img
                        src={vegetarianIcon}
                        style={{ height: 25, width: 25 }}
                      />
                    </div>
                    <div className="mb-2 mx-1 ">
                      {language == "english" ? "Vegetarian" : "نباتي"}
                    </div>
                  </div>
                )}
                {nutritionalFacts?.containsGluten && (
                  <div
                    className="mb-1"
                    style={{
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      width: 75,
                    }}
                  >
                    <div className="mb-2">
                      <img
                        src={glutenIcon}
                        style={{ height: 25, width: 25 }}
                        alt="Gluten"
                      />
                    </div>
                    <div className="mb-2">
                      {language === "english" ? "Gluten" : "يحتوي على الغلوتين"}
                    </div>
                  </div>
                )}

                {nutritionalFacts?.containsNutsSesame && (
                  <div
                    className="mb-1"
                    style={{
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      width: 75,
                    }}
                  >
                    <div className="mb-2">
                      <img
                        src={nutsSesameIcon}
                        style={{ height: 25, width: 25 }}
                        alt="Nuts/Sesame"
                      />
                    </div>
                    <div className="mb-2">
                      {language === "english"
                        ? "Nuts/Sesame"
                        : "يحتوي على مكسرات/سمسم"}
                    </div>
                  </div>
                )}

                {nutritionalFacts?.containsDairy && (
                  <div
                    className="mb-1"
                    style={{
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      width: 75,
                    }}
                  >
                    <div className="mb-2">
                      <img
                        src={dairyIcon}
                        style={{ height: 25, width: 25 }}
                        alt="Dairy"
                      />
                    </div>
                    <div className="mb-2">
                      {language === "english" ? "Dairy" : "يحتوي على ألبان"}
                    </div>
                  </div>
                )}

                {nutritionalFacts?.containsEgg && (
                  <div
                    className="mb-1"
                    style={{
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      width: 75,
                    }}
                  >
                    <div className="mb-2">
                      <img
                        src={eggIcon}
                        style={{ height: 25, width: 25 }}
                        alt="Egg"
                      />
                    </div>
                    <div className="mb-2">
                      {language === "english" ? "Egg" : "يحتوي على بيض"}
                    </div>
                  </div>
                )}

                {nutritionalFacts?.containsSeafoodShellfish && (
                  <div
                    className="mb-1"
                    style={{
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      width: 75,
                    }}
                  >
                    <div className="mb-2">
                      <img
                        src={seafoodShellfishIcon}
                        style={{ height: 25, width: 25 }}
                        alt="Seafood/Shellfish"
                      />
                    </div>
                    <div className="mb-2">
                      {language === "english"
                        ? "Seafood/Shellfish"
                        : "يحتوي على مأكولات بحرية/قشريات"}
                    </div>
                  </div>
                )}

                {nutritionalFacts?.containsChilli && (
                  <div
                    className="mb-1"
                    style={{
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      width: 75,
                    }}
                  >
                    <div className="mb-2">
                      <img
                        src={chilliIcon}
                        style={{ height: 25, width: 25 }}
                        alt="Chilli"
                      />
                    </div>
                    <div className="mb-2">
                      {language === "english" ? "Chilli" : "يحتوي على شطة"}
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    themeColor: state.store.store.settings.dark,
    cart_items: state.cart.cart,
    settings: state.store.store.settings,
    store: state.store.store,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(NutritionalFacts);
